import { NetworkState, type NetworkLifecycleCallbacks } from "@/app/shared/lifecycle";

type RunParams<T> = {
    source: string;
    lifecycle?: NetworkLifecycleCallbacks;
    meta?: Record<string, unknown>;
    onStart?: () => void;
    onSuccess?: (result: T) => { ok: true } | { ok: false; message: string };
    onError?: (message: string) => void;
    onFinally?: () => void;
    task: () => Promise<T>;
    mapError?: (e: unknown) => string;
};

export async function runWithNetworkLifecycle<T>({
                                                     source,
                                                     lifecycle,
                                                     meta,
                                                     onStart,
                                                     onSuccess,
                                                     onError,
                                                     onFinally,
                                                     task,
                                                     mapError,
                                                 }: RunParams<T>): Promise<T | null> {
    onStart?.();
    lifecycle?.onStateChange?.({
        state: NetworkState.Loading,
        source,
        meta,
        updatedAt: Date.now(),
    });

    try {
        const result = await task();

        const validation = onSuccess?.(result) ?? { ok: true as const };

        if (!validation.ok) {
            onError?.(validation.message);
            lifecycle?.onStateChange?.({
                state: NetworkState.Error,
                source,
                error: validation.message,
                meta,
                updatedAt: Date.now(),
            });
            return null;
        }

        lifecycle?.onStateChange?.({
            state: NetworkState.Success,
            source,
            meta,
            updatedAt: Date.now(),
        });

        return result;
    } catch (e) {
        const message = mapError?.(e) ?? (e instanceof Error ? e.message : "Неизвестная ошибка");
        onError?.(message);

        lifecycle?.onStateChange?.({
            state: NetworkState.Error,
            source,
            error: message,
            meta,
            updatedAt: Date.now(),
        });

        return null;
    } finally {
        onFinally?.();
    }
}